import { useRef } from 'react';

import { css } from '@betterment/samba-styled-system/css';

import useCapitalizeWindowEvents from '../hooks/useCapitalizeWindowEvents';

interface Props {
  webviewUrl: string;
}

const CapitalizeTransactionDetailsWebview: React.FC<Props> = ({ webviewUrl }) => {
  const ref = useRef<HTMLIFrameElement>(null);

  useCapitalizeWindowEvents({
    onCapitalizeExit: () => {
      ref.current?.dispatchEvent(new CustomEvent('modal:close', { bubbles: true }));
    },
  });

  return (
    <iframe
      ref={ref}
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={0}
      className={css({
        position: 'absolute',
        width: '100%',
        height: '100%',
        border: 'none',
      })}
      src={webviewUrl}
      title="Capitalize transaction details"
    />
  );
};

export default CapitalizeTransactionDetailsWebview;
